import { render } from "./PageListarCategoriaAtendimento.vue?vue&type=template&id=641934c7"
import script from "./PageListarCategoriaAtendimento.vue?vue&type=script&lang=js"
export * from "./PageListarCategoriaAtendimento.vue?vue&type=script&lang=js"

import "./PageListarCategoriaAtendimento.vue?vue&type=style&index=0&id=641934c7&lang=css"
/* custom blocks */
import block0 from "./PageListarCategoriaAtendimento.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__